/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { BankAccount } from '@src/app/model/bankAccount';
import { uuid } from '@src/app/model/abstract-object';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface ManualRec {
    bankAccountId: uuid,
    fromDate: string,
    openingBal: number,
    toDate: string,
    closingBal: number,
}
@Injectable({
    providedIn: 'root'
})
export class BankAccountService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);


    protected get baseUrl(): string {
        return this.getAjaxPath('bank-accounts');
    }

    protected cache: BankAccount[];
    protected typeString = 'bank-accounts';

    getBalance<AbstractObject>(id: uuid, date: string, includeDate = false): Observable<AbstractObject> {
        const httpParams = new HttpParams().set('bankAccountId', id).set('date', date).set('includeDate', includeDate);

        return this.http.get<AbstractObject>(this.baseUrl + '/getBalance', { params: httpParams })
            .pipe(
                catchError(this.handleOneError<AbstractObject>('getBankBalance', null))
            );
    }

    postReconciliation(match: ManualRec, teamId = null) {
        const options = this.getSimpleOptions(teamId);
        return this.http.post(this.baseUrl + '/reconcile', match, options);
    }


}
